import React, {
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import "datatables.net-bs4";
import { Link } from "react-router-dom";
import { useAgents } from "../../utils/agents";
import { NavItem, NavTabs } from "../layout/Nav";

export default function AgentContent() {
    const { agents, loaded, deleteAgentByIdWithToken } = useAgents();
    const [selectedAgentId, setSelectedAgentId] = useState(() => (
        typeof window !== "undefined"
            ? window.localStorage.getItem("selectedAgentId") || ""
            : ""
    ));
    const datatable = useRef(null);


    useEffect(() => {
        if (datatable.current) {
            datatable.current.destroy();
            datatable.current = null;
        }
    }, [agents]);

    const agentsArray = useMemo(() => (
        Array.isArray(agents)
            ? agents
            : Object.keys(agents).map((key) => ({
                id: key,
                ...agents[key],
            }))
    ), [agents]);

    useEffect(() => {
        if (agentsArray.length === 0) return;
        const hasSelectedAgent = agentsArray.some((agent) => agent.id === selectedAgentId);
        if (!hasSelectedAgent) {
            setSelectedAgentId(agentsArray[0].id);
        }
    }, [agentsArray, selectedAgentId]);

    useEffect(() => {
        if (!selectedAgentId || typeof window === "undefined") return;
        window.localStorage.setItem("selectedAgentId", selectedAgentId);
    }, [selectedAgentId]);

    const selectedAgent = useMemo(() => (
        agentsArray.find((agent) => agent.id === selectedAgentId) || agentsArray[0]
    ), [agentsArray, selectedAgentId]);

    const handleDeleteAgent = async (agentId) => {
        console.log('handleDeleteAgent Callled', agentId)
        try {
            await deleteAgentByIdWithToken(agentId);
        } catch (error) {
            throw Error('unable to delete agent')
        }
    }
    if (!loaded) {
        return (
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                    <div className="">
                        <div className="kt-portlet__body">
                            <div className="text-center">Chargement...</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className="body-container">
            <div>

                <div>
                    <h3 className="title">Agents</h3>
                        {selectedAgent ? (
                    <div className="d-flex justify-content-between align-items-center title-container mb-4">
                        <NavTabs className="titles">
                            <NavItem>
                                <Link to="/agents">Inbox</Link>
                            </NavItem>
                            <NavItem className="active">
                                <Link to="/settings">Settings</Link>
                            </NavItem>
                        </NavTabs>
                        <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
                            <label className="mb-0 text-muted" htmlFor="agent-selector-settings">Agent</label>
                            <select
                                id="agent-selector-settings"
                                className="form-control"
                                style={{ minWidth: "240px" }}
                                value={selectedAgent.id}
                                onChange={(e) => setSelectedAgentId(e.target.value)}
                            >
                                {agentsArray.map((agentItem) => (
                                    <option key={agentItem.id} value={agentItem.id}>
                                        {agentItem.label || agentItem.businessName || agentItem.twilioPhoneNumber}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                        ) : null}

                </div>
            </div>
            {selectedAgent ? (
                <div className="kt-portlet kt-portlet--tabs">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">Détails de l'Agent</h3>
                        </div>
                    </div>
                    <form className="kt-form">
                        <div className="kt-portlet__body">
                            <div className="kt-section kt-section--first">
                                <div className="kt-section__body">

                                    <div className="form-group row">
                                        <label className="col-lg-3 col-form-label">Numéro Twilio:</label>
                                        <div className="col-lg-6">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="twilioPhoneNumber"
                                                value={selectedAgent.twilioPhoneNumber || ""}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-lg-3 col-form-label">SID Twilio:</label>
                                        <div className="col-lg-6">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="twilioAccountSID"
                                                value={selectedAgent.twilioAccountSID || ""}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-lg-3 col-form-label">Auth Token Twilio:</label>
                                        <div className="col-lg-6">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="twilioAuthToken"
                                                value={selectedAgent.twilioAuthToken || ""}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-lg-3 col-form-label">Label:</label>
                                        <div className="col-lg-6">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="label"
                                                value={selectedAgent.label || ""}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-lg-3 col-form-label">Nom d'entreprise:</label>
                                        <div className="col-lg-6">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="businessName"
                                                value={selectedAgent.businessName || ""}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-lg-3 col-form-label">Prompt:</label>
                                        <div className="col-lg-6">
                                            <textarea
                                                className="form-control"
                                                name="prompt"
                                                value={selectedAgent.prompt || ""}
                                                disabled
                                                rows={4}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions" style={{ display: "flex", gap: "1rem" }}>
                                <Link to={`/edit-agent/${selectedAgent.id}`} className="btn btn-primary" >Modifier Agent</Link>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => handleDeleteAgent(selectedAgent.id)}
                                >
                                    Supprimer Agent
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            ) : (
                <div className="kt-portlet kt-portlet--tabs">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">Aucun Agent Trouvé</h3>
                        </div>
                    </div>
                    <div className="kt-portlet__body">
                        <div className="text-center">
                            <Link
                                to="/add-agent"
                                className="btn btn-brand btn-elevate btn-icon-sm text-nowrap"
                            >
                                Créer un agent
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
